export default __webpack_public_path__ + "assets/models/6b3692eb9e19ae80b5bb76fa80e17e86.glb";